import React from "react";
import { Stack } from "react-bootstrap";

const UserBadge = ({ photo, name, surname }) => {
  return (
    <Stack gap={2} className="d-flex justify-content-center align-items-center">
      <img
        src={photo ?? "/no_img.png"}
        alt="immagine profilo"
        style={{
          borderRadius: "50%",
          width: "100px",
          height: "100px",
          objectFit: "cover",
        }}
      />
      <span
        style={{
          fontSize: "14px",
          color: "#888888",
        }}
      >
        {name} {surname}
      </span>
    </Stack>
  );
};

export default UserBadge;
